import { render, staticRenderFns } from "./QuizBankList.vue?vue&type=template&id=439833ca&scoped=true"
import script from "./QuizBankList.vue?vue&type=script&lang=js"
export * from "./QuizBankList.vue?vue&type=script&lang=js"
import style0 from "./QuizBankList.vue?vue&type=style&index=0&id=439833ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439833ca",
  null
  
)

export default component.exports